// import axios from "axios";

// /**
//  * Send user question to Combat Chatbot API
//  * @param {string} message
//  * @returns {Promise<{answer: string, session_id: string}>}
//  */

// export const sendCombatChatMessage = async (message) => {
//   try {
//     const response = await axios.post(
//       "https://combatsolutions.co.in/chat/",
//       {
//         message,
//       }
//     );

//     return response.data;
//     /*
//       {
//         session_id: "...",
//         question: "...",
//         rephrased_question: "...",
//         answer: "..."
//       }
//     */

//   } catch (error) {
//     console.error("Combat Chatbot API Error:", error);

//     throw new Error(
//       error?.response?.data?.error || "Combat chatbot is unavailable"
//     );
//   }
// };
import axios from "axios";

const SESSION_STORAGE_KEY = "combat_chat_session_id";

/**
 * Generate unique session ID
 * Example: 2552002
 */
const generateSessionId = () => {
  return Math.floor(1000000 + Math.random() * 9000000).toString();
};

/**
 * Get existing session ID from localStorage
 * OR create a new one if not exists
 */
const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_STORAGE_KEY);

  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  }

  return sessionId;
};

/**
 * Send user question to Combat Chatbot API
 * @param {string} message
 * @returns {Promise<{answer: string, session_id: string}>}
 */
export const sendCombatChatMessage = async (message) => {
  try {
    // Get session ID
    const sessionId = getSessionId();

    // API request
    const response = await axios.post(
      "https://combatsolutions.co.in/chat/",
      {
        message,
        session_id: sessionId,
      }
    );

    return response.data;

    /*
      Expected Response:
      {
        session_id: "...",
        question: "...",
        rephrased_question: "...",
        answer: "..."
      }
    */

  } catch (error) {
    console.error("Combat Chatbot API Error:", error);

    throw new Error(
      error?.response?.data?.error ||
      "Combat chatbot is unavailable"
    );
  }
};